/* src/app/components/actions-menu/actions-menu.component.scss */
button {
  margin: 0;
  min-height: 0;
  padding: 8px 5px;
  border-radius: 10px;
}
button ion-icon {
  margin: 0;
  font-size: 20px;
}
button span {
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
button:hover {
  background-color: #f6f6f6;
}
button.edit-button {
  color: #0c8ce9;
}
button.edit-button:hover {
  background-color: rgba(12, 141, 233, 0.1490196078);
}
button.remove-button {
  color: #eb445a;
}
button.remove-button:hover {
  background-color: rgba(235, 68, 90, 0.15);
}
.gap-five {
  gap: 5px;
}
.color-cyan {
  color: #0c8ce9;
}
/*# sourceMappingURL=actions-menu.component-AXK6RSDB.css.map */
